import _schedules                          from './schedules';
import _hours                              from './hours';
import _substitutionPlans                  from './substitution-plans';
import _classes                            from './classes';
import _teachers                           from './teachers';
import _subjects                           from './subjects';
import _rooms                              from './rooms';
import _courses                            from './courses';
import _lessons                            from './lessons';
import _holidays                           from './holidays';
import _schoolYears                        from './school-years';

export default class {
  static schedules           = _schedules;
  static hours               = _hours;
  static substitutionPlans   = _substitutionPlans;
  static classes             = _classes;
  static teachers            = _teachers;
  static subjects            = _subjects;
  static rooms               = _rooms;
  static courses             = _courses;
  static lessons             = _lessons;
  static holidays            = _holidays;
  static schoolYears         = _schoolYears;
}